// Action Types - defined here to avoid circular dependencies
export const OPEN_CHAT_DRAWER = 'OPEN_CHAT_DRAWER';
export const SET_SELECTED_CHAT = 'SET_SELECTED_CHAT';
export const SET_NEW_CONVERSATION_DATA = 'SET_NEW_CONVERSATION_DATA';

const initialState = {
    isDrawerOpen: false,
    selectedChatId: null,
    newConversationData: null
};

const chatReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_CHAT_DRAWER:
            return {
                ...state,
                isDrawerOpen: action.payload
            };
        case SET_SELECTED_CHAT:
            return {
                ...state,
                selectedChatId: action.payload
            };
        case SET_NEW_CONVERSATION_DATA:
            return {
                ...state,
                newConversationData: action.payload
            };
        default:
            return state;
    }
};

export default chatReducer;